import(/* webpackMode: "eager", webpackExports: ["StayHospitalityLandingClient"] */ "/workspace/src/components/profile/StayHospitalityLandingClient.tsx");
